import { type AgentRunSummary, formatTimestamp } from '~/entities/document-agent'
import { Select } from '~/shared/ui'

export function RunSelector({
  runs,
  value,
  onChange,
}: {
  runs: AgentRunSummary[]
  value: string | undefined
  onChange: (runId: string) => void
}) {
  return (
    <Select
      className="w-[380px]"
      label="Run"
      placeholder="Select a run"
      value={value ?? ''}
      onValueChange={(runId) => onChange(String(runId))}
    >
      {runs.map((run, index) => (
        <Select.Item
          key={run.run_id}
          value={run.run_id}
        >
          {[
            formatTimestamp(run.created),
            run.run_label,
            run.run_status,
            index === 0 ? 'newest' : null,
          ]
            .filter(Boolean)
            .join(' · ')}
        </Select.Item>
      ))}
    </Select>
  )
}
